import React from 'react'
import {
  OptionWrapper,
  OptionWrapperProps,
} from 'src/editor/layout/sidebar/settings/option-wrapper'
import { Input, InputProps } from 'src/editor/shared/ui-lib/input'
import ErrorUi from 'client/components/core/Error/ui/ErrorUi'

interface TextInputControlProps
  extends Omit<InputProps, 'onChange' | 'onReset' | 'width' | 'className'>,
    OptionWrapperProps {
  update: (value: string) => void
  wrapperProps?: OptionWrapperProps
  error?: string
}

export const TextInputControl = ({
  wrapperProps,
  update,
  error,
  ...props
}: TextInputControlProps) => {
  return (
    <OptionWrapper {...wrapperProps}>
      <Input onChange={update} width="w-full" {...props} />
      {error ? <ErrorUi dangerouslySetInnerHTML={{ __html: error }} /> : null}
    </OptionWrapper>
  )
}
